import { render } from "./CompanyAccount-PricingAndBilling.vue?vue&type=template&id=29ae33fe&scoped=true"
import script from "./CompanyAccount-PricingAndBilling.vue?vue&type=script&lang=js"
export * from "./CompanyAccount-PricingAndBilling.vue?vue&type=script&lang=js"

import "./CompanyAccount-PricingAndBilling.vue?vue&type=style&index=0&id=29ae33fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29ae33fe"]])

export default __exports__